import { AdvancedTourStep } from '../shared-types';
import { ComponentTourProps } from './component-tour-props';

export function getTaskNodeTourSteps({ defaultStyles }: ComponentTourProps): AdvancedTourStep[] {
	return [
		{
			id: 'task-node-copy',
			selector: '[data-tour="task-node-0-copy"]',
			content: 'Copy the task, this will copy any configuration on the task too.',
		},
		{
			id: 'task-node-delete',
			selector: '[data-tour="task-node-0-delete"]',
			content:
				'Delete this task, this will remove the entire task including configuration from your flow version.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
